module.exports = __webpack_public_path__ + "static/favicon-f74e327a01d92dcefb7e238fe9952e35.ico";